import { ref, readonly, onScopeDispose, computed } from 'vue'

const lockCount = ref(0)
let originalBodyOverflow: string | null = null
let originalBodyPaddingRight: string | null = null

export function useBodyScrollLock() {
  const isLockedByThisInstance = ref(false)

  function getScrollbarWidth(): number {
    if (typeof window === 'undefined') {
      return 0
    }

    return window.innerWidth - document.documentElement.clientWidth
  }

  function lock(): void {
    if (typeof document === 'undefined' || isLockedByThisInstance.value) {
      // Already locked or no document
      return
    }

    if (lockCount.value === 0) {
      originalBodyOverflow = document.body.style.overflow
      originalBodyPaddingRight = document.body.style.paddingRight

      const scrollbarWidth = getScrollbarWidth()

      document.body.style.overflow = 'hidden'

      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`
      }
    }

    lockCount.value++
    isLockedByThisInstance.value = true
  }

  function unlock(): void {
    if (typeof document === 'undefined' || !isLockedByThisInstance.value) {
      // Not locked or no document
      return
    }

    lockCount.value--
    isLockedByThisInstance.value = false

    if (lockCount.value === 0) {
      document.body.style.overflow = originalBodyOverflow!
      document.body.style.paddingRight = originalBodyPaddingRight!

      // Reset the original values
      originalBodyOverflow = null
      originalBodyPaddingRight = null
    }
  }

  // Ensure unlock is called if component unmounts
  onScopeDispose(() => {
    if (isLockedByThisInstance.value) {
      unlock()
    }
  })

  return {
    lock,
    unlock,
    isLocked: readonly(computed(() => lockCount.value > 0)),
  }
}
